<template>
    <section v-if="pageLoader">
        <div class="page-loader">Загрузка...</div>
    </section>
    <section
        v-else-if="!infoPagesIsEmpty('infoPages')"
        class="info-page">
            <h1 class="heading">{{ infoPages.title }}</h1>
            <div
                class="info-block"
                v-html="infoPages.text"
            ></div>
    </section>
    <section
        v-else
        class="info-page"
    ><div class="info-block">Страница в разработке</div></section>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'InfoPage',
        data() {
            return {
                pageLoader: true,
                pageName: ''
            }
        },
        computed: {
            ...mapGetters({
                infoPages: 'infoPages/fetchInfoPages',
                infoPagesIsEmpty: 'infoPages/isEmpty'
            })
        },
        mounted() {
            this.pageName = this.$route.name;
            this.$store.dispatch('infoPages/get', this.pageName)
            .then(() => {
                this.pageLoader = false;
            })
            .catch(() => {
                this.pageLoader = false;
            });
        },
        watch: {
            '$route' (to, from) {
                if (to != from) {
                    this.pageLoader = true;
                    this.pageName = this.$route.name;
                    this.$store.dispatch('infoPages/get', this.pageName)
                    .then(() => {
                        this.pageLoader = false;
                    })
                    .catch(() => {
                        this.pageLoader = false;
                    });
                }
            }
        }
    }
</script>

<style lang="scss">
    @import '~@/assets/styles/pages/_info-page';
</style>
